// extracted by mini-css-extract-plugin
module.exports = {"closeButtonWrap":"Close_closeButtonWrap__Y7TZL","small":"Close_small__2caX7","medium":"Close_medium__olm9Y"};